<template>
	<div class='route_container'>
		<div class="container-fluid d-flex flex-column align-items-center justify-content-center breadcrumb-nav-post bg-gradient py-5 px-0 mt-5">
			<h1 class="display-2 text-shadow mt-5 px-3">{{ $t("forum_title") }}</h1>
			<div class="d-flex align-items-center justify-content-center py-3 px-3">
				<form class="form-inline">
					<input class="form-control form-forum mr-sm-2" type="text" ref="search" :placeholder="$t('forum_search_game')" aria-label="Search" v-model="searchGame"/>
					<button class="btn btn-outline-success btn-search my-2 my-sm-0" type="button">{{ $t('forum_search_forum') }}</button>
				</form>
			</div>
		</div>
		<div class="container-fluid px-0">
			<div class="bg-dark-translucid justify-content-between align-items-center h-50px mb-3"></div>
			<div class="container-custom">
				<div class="tab-content">
					<b-tabs class="col-12 p-0 d-flex flex-column tab-content mb-5">
						<b-tab active>
							<template #title>
								<font-awesome-icon :icon='["fa", "th"]' />
							</template>
							<div class="grid-square d-block">
								<div class="animated slideInUp fast d-flex flex-row flex-wrap pt-lg-3 pb-5">
									<div class="col-xl-3 col-lg-4 col-sm-6 col-12"
                                        v-for='(game, $index) in games.filter(x => x.name.toLowerCase().includes(searchGame.toLowerCase()))'
                                        :key='"forum-game-link-" + $index'
                                    >
										<div class="card small-card flex-column bg-gray-900 border border-green-lighter mb-lg-3 mt-3">
											<div class="d-flex flex-column 111">
												<router-link :to='"/" + $store.state.meta.lang + "/game/" + game.seoname' class="h-100">
													<div class="img-container">
														<div class="col overflow-hidden px-0">
															<div class="overlay">
																<img :src="game.game_logo" class="logo-overlay card-img-overlay d-flex align-items-center img-fluid m-auto" alt="--">
															</div>
															<div class="overflow-hidden logo-img-container">
																<img class="gameCard-img" :src="game.game_banner" alt="...">
															</div>
														</div>
													</div>
												</router-link>
												<div class="card-body text-white position-relative border-top border-green-lighter py-2">
													<div class="d-flex flex-column justify-content-center h-100">
														<div><h6 class="card-titletext-shadow my-0"> {{game.name}} </h6></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-tab>
						<b-tab>
							<template #title>
								<font-awesome-icon :icon='["fa", "bars"]' />
							</template>
							<div class="card bg-gray-900 box-shadow border border-green-lighter p-3 my-3">
								<div class="container-fluid d-flex flex-column pb-5">
                                    <div class="animated slideInUp fast pl-md-0 pr-lg-5 pr-md-3 px-0">
                                        <div class="d-flex flex-row flex-wrap mx-0">
                                            <div class="game-card-rectangular col-md-6 col-12"
                                                v-for='(game, $index) in games.filter(x => x.name.toLowerCase().includes(searchGame.toLowerCase()))'
                                                :key='"forum-game-link-" + $index'

                                            >
                                                <router-link :to='"/" + $store.state.meta.lang + "/game/" + game.seoname' class="forum-link">
                                                    <div class="d-flex flex-row border-bottom border-green-lighter py-3">
                                                        <div class="d-flex align-items-center justify-content-center position-relative pl-3">
                                                            <div class="position-relative">
																<div class="overlay">
																	<img class="logo-overlay card-img-overlay m-auto" :src="game.game_logo"  alt="--">
																</div>
                                                                <div class="bg-img-container overflow-hidden box-shadow">
                                                                    <img class="gameCard-img" :src="game.game_banner" alt="...">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex flex-sm-row flex-column w-100">
                                                            <div class="col d-flex flex-column justify-content-center">
                                                                <div><h4 class="card-title h6 text-white text-shadow mb-0"> {{game.name}} </h4></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
							</div>
						</b-tab>
					</b-tabs >
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import logger from '../../assets/js/logger'

	export default {
		name: 'landing',
		components: {
		},
		data () {
			return {
				searchGame: '',
				small_img:  require("./../../assets/img/new-home/zula-338x160.png"),
			}
		},
		computed: {
			games () { // newly added
				let data = this.$store.getters.alphabetizedGames;

				data.map((x,i)=>{
					x.game_logo   = `https://cdn${(i+1)%16}.idcgames.com/storage/image/${x.id}/game_logo/2x1_1-8_0.png`;
					x.game_banner = `https://cdn${(i+1)%16}.idcgames.com/storage/image/${x.id}/game_banner/2x1_1-4_72.jpg`;
					return x;
				})

				return data
			},

			categories () {
				return this.$store.getters.alphabetizedCategories
			}

		},
		methods: {

		},
		watch: {
			searchGame: function(){
			}
		},
		created () {
      		logger('landing')
		},
		destroyed () {
    },
    mounted() {
      this.$store.dispatch('setTitle', '')
      this.$refs.search.focus();
    },
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.threads_main {
		display: flex;
		flex-direction: column;
		align-items: center;

		@at-root #{&}__title {
			color: $color__darkgray--darker;
			cursor: default;
			font-weight: 500;
			font-size: 2rem;
    		margin-bottom: 1.5rem;
		}
	}

	.thread_sorting {
		margin-bottom: 1rem;
		display: flex;
		justify-content: space-between;

		@at-root #{&}__display {
			padding-right: 0.5rem;
			border-right: thin solid $color__gray--primary;
			margin-right: 1.25rem;
			width: 10rem;
		}

		@at-root #{&}__add_and_categories {
			.select_button {
				display: none;
			}
		}
	}

	.threads_main__game_box {
		height: 0%;
		background: #fff;
		border-radius: 0.25rem;
		border: thin solid $color__gray--darker;
		padding: 1.5rem 0 1rem 2rem;

		@at-root #{&}__menu_item {
			cursor: pointer;
			margin-top: 0.5rem;
      width: 50%;
			position: relative;
			display: inline-flex;
      flex-direction: row;
			grid-column-gap: 1rem;
			text-decoration: none;
			background-image: none;
			font-weight: normal;

			@at-root #{&}__logo {
				align-self: flex-start;
				display: inline-block;
				height: 3rem;
				width: 3rem;
				margin-top: 0.5rem;
        border-radius: 0.5rem;
				// background-color: $color__text--secondary;
				transition: all 0.2s;
        object-fit: cover;
			}

			@at-root #{&}__text {
				filter: saturate(0.75), brightness(0.75);
        align-self: center;
			}


			@at-root #{&}--selected {
				font-weight: 600;
			}
		}
	}
	.threads_main__game_box {
		margin-left: 1rem;
		width: calc(100% - 10rem);
	}

	.threads_main__load_new {
		@extend .button;

		font-size: 1.25rem;
		margin: 0 0 1rem 0;
		background-color: $color__lightgray--primary;
		border-color: $color__gray--darker;
		width: 100%;
		font-weight: 300;
	}

	.thread {
		background-color: #fff;
		padding: 0.5rem 0;
		cursor: default;
		text-align: left;
		transition: background-color 0.2s;

		&:hover {
			background-color: $color__lightgray--primary;
		}

		td, th {
			padding: 0.3rem 0.5rem;
			border-bottom: solid thin $color__lightgray--primary;
		}

		@at-root #{&}--header {
			&:hover {
				background-color: #fff;
			}

			th {
				font-weight: 400;
				padding-bottom: 0.25rem;
				border-bottom: thin solid $color__lightgray--darkest;
			}
		}

		@at-root #{&}__section {
			padding: 0 0.5rem;
		}

		@at-root #{&}__user {
			display: inline-block;
		}
		@at-root #{&}__date {
			color: $color__text--secondary;
			display: inline-block;
		}
	}

	@media (max-width: $breakpoint--tablet) {
		.thread_sorting {
			flex-direction: column-reverse;
			align-items: left;

			@at-root #{&}__add_and_categories {
				width: 100%;
				display: flex;
				justify-content: space-between;
				margin-bottom: 0.5rem;

				.select_button {
					display: inline-block;
				}
			}
		}

		.threads_main__game_box {
			width: 100%;
			margin-left: 0;
		}
	}

	@media (max-width: $breakpoint--tablet) and (min-width: $breakpoint--phone) {
		.route_container {
			padding: 1rem 2rem;
		}
	}

	.nav-link{
		padding: 0;
		text-decoration: none!important;
	}
	.nav-link:hover{
		text-decoration: none!important;
	}

/* >> */
.small-card .overlay {
    background-image: linear-gradient(135deg, rgba(0, 0, 0, 0) 30%, #000000 100%);
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
}

.small-card .card-img-overlay {
    padding: 1.5rem;
}

.small-card:hover .system-btns {
    display: none;
}

.small-card:hover .cart-btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.small-card:hover .logo-overlay {
    padding: 1rem;
    -webkit-transition: all ease-out .4s;
    transition: all ease-out .4s;
}

.small-card:hover .overlay {
    background-image: linear-gradient(135deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.2) 30%, #000000 100%);
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
}

.game-card-rectangular img {
    -o-object-fit: cover;
    object-fit: cover;
    height: 76px;
}
.game-card-rectangular {
  -webkit-transition: all .1s ease-in-out;
  transition: all .1s ease-in-out;
  cursor: pointer; }
.game-card-rectangular .cart-btn {
	display: none; }
.game-card-rectangular span.h6.text-shadow.mb-0 {
	margin-top: -4px; }
.game-card-rectangular:hover {
	background-color: #314954;
	-webkit-box-shadow: 1px 3px 8px 3px rgba(0, 0, 0, 0.4);
		box-shadow: 1px 3px 8px 3px rgba(0, 0, 0, 0.4);
	-webkit-transition: all .1s ease-in-out;
	transition: all .1s ease-in-out; }
.game-card-rectangular:hover .cart-btn {
	display: block; }
.game-card-rectangular:hover .card-img-overlay {
	padding: .25rem;
	-webkit-transition: all ease-out .4s;
	transition: all ease-out .4s; }
.game-card-rectangular:hover .logo-img-container {
	background-image: radial-gradient(circle, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5));
	-webkit-transition: all .1s ease-in-out;
	transition: all .1s ease-in-out; }
.game-card-rectangular .bg-img-container {
height: 76px;
width: 136px; }
.game-card-rectangular .logo-img-container {
-webkit-transition: all .1s ease-in-out;
transition: all .1s ease-in-out; }
.game-card-rectangular .card-img-overlay {
position: absolute;
top: 0;
right: 0;
bottom: 0;
left: 0;
padding: .5rem;
width: 100% }
</style>
